import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Star, Eye, EyeOff, Trash2 } from "lucide-react";
import { api, apiErr } from "@/lib/api";

export default function AdminReviews() {
  const [rows, setRows] = useState([]);
  const [status, setStatus] = useState("");

  const load = () => api.get(`/admin/reviews${status ? `?status=${status}` : ""}`).then((r) => setRows(r.data)).catch(() => {});
  useEffect(() => { load(); /* eslint-disable-next-line */ }, [status]);

  const setSt = async (id, s) => {
    try { await api.put(`/admin/reviews/${id}/status`, { status: s }); toast.success(s === "hidden" ? "Review hidden" : "Review published"); load(); }
    catch (e) { toast.error(apiErr(e)); }
  };
  const del = async (id) => {
    if (!window.confirm("Delete this review?")) return;
    try { await api.delete(`/admin/reviews/${id}`); toast.success("Deleted"); load(); }
    catch (e) { toast.error(apiErr(e)); }
  };

  return (
    <div data-testid="admin-reviews">
      <div className="flex items-center justify-between flex-wrap gap-2 mb-4">
        <div>
          <h1 className="text-2xl font-bold">Reviews &amp; Ratings</h1>
          <p className="text-slate-500 text-sm">Customer reviews moderate karein — app ke saath 2-way synced.</p>
        </div>
        <select data-testid="review-status-filter" value={status} onChange={(e) => setStatus(e.target.value)} className="border border-slate-300 rounded-lg px-3 py-2 text-sm">
          <option value="">All</option>
          <option value="published">Published</option>
          <option value="hidden">Hidden</option>
        </select>
      </div>
      {!rows.length ? <p className="text-slate-400 text-sm py-10 text-center">Abhi koi review nahi.</p> : (
        <div className="space-y-3">
          {rows.map((r) => (
            <div key={r.id} data-testid={`review-row-${r.id}`} className="bg-white border border-slate-200 rounded-xl p-4">
              <div className="flex items-start justify-between gap-3 flex-wrap">
                <div className="min-w-0">
                  <div className="flex items-center gap-2">
                    <span className="flex items-center gap-0.5">{[1, 2, 3, 4, 5].map((i) => <Star key={i} size={14} className={i <= r.rating ? "fill-amber-400 text-amber-400" : "text-slate-200"} />)}</span>
                    <span className={`text-[10px] font-bold px-2 py-0.5 rounded-full ${r.status === "published" ? "bg-emerald-100 text-emerald-700" : "bg-slate-200 text-slate-500"}`}>{r.status}</span>
                  </div>
                  {r.title && <p className="font-bold text-sm mt-1">{r.title}</p>}
                  <p className="text-sm text-slate-600 mt-0.5">{r.comment}</p>
                  <p className="text-[11px] text-slate-400 mt-1">{r.user_name} · {r.product_name || r.product_id} · {new Date(r.created_at).toLocaleDateString("en-IN")}</p>
                </div>
                <div className="flex items-center gap-2 shrink-0">
                  {r.status === "published"
                    ? <button data-testid={`review-hide-${r.id}`} onClick={() => setSt(r.id, "hidden")} className="p-2 bg-slate-100 hover:bg-slate-200 rounded-lg" title="Hide"><EyeOff size={15} /></button>
                    : <button data-testid={`review-publish-${r.id}`} onClick={() => setSt(r.id, "published")} className="p-2 bg-emerald-50 hover:bg-emerald-100 text-emerald-700 rounded-lg" title="Publish"><Eye size={15} /></button>}
                  <button data-testid={`review-delete-${r.id}`} onClick={() => del(r.id)} className="p-2 bg-rose-50 hover:bg-rose-100 text-rose-600 rounded-lg" title="Delete"><Trash2 size={15} /></button>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
